export default __webpack_public_path__ + "c3f3b242267fd52f5fd2f344d5903846.svg";